import React from "react";
import { createRoot } from "react-dom/client";
import "@hotwired/turbo-rails";
import { Application } from "@hotwired/stimulus";
import $ from "jquery";
import Notifications from "./components/commons/Notifications";

const sentryMeta = document.querySelector('meta[name="sentry-dsn"]');
const SENTRY_DSN = sentryMeta ? sentryMeta.getAttribute("content") : null;

import * as Sentry from "@sentry/react";
import I18n from "i18n-js";
import { createPopper } from "@popperjs/core";
import "bootstrap";
import "@fortawesome/fontawesome-free/js/all";
import _ from 'lodash';
import select2 from "select2";

import "chartjs-adapter-date-fns";
import "chartkick/chart.js";


// Sentry Init
Sentry.init({
  dsn: SENTRY_DSN,
  integrations: [ Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.5,
  environment: "frontend",
});
Sentry.setTag("client", "react-frontend");
const userMeta = document.querySelector('meta[name="current-user"]');
if (userMeta) {
  try {
    const userData = JSON.parse(userMeta.getAttribute("content") || "{}");
    Sentry.setUser({
      id: userData.id,
      email: userData.email,
    });
  } catch (e) {
    console.error("Error parseando current-user meta", e);
  }
}

import "./sentry-axios-interceptor";

//  Stimulus Init
import ReactController from "./controllers/react_controller";
const application = Application.start();
application.register("react", ReactController);

// Inicializar i18n con un objeto vacío por defecto
let i18nTranslations = {};
try {
  i18nTranslations = require("../assets/builds/i18n.json");
} catch (e) {
  console.warn("No se encontró el archivo de traducciones i18n.json");
}

I18n.translations = i18nTranslations;
I18n.default_locale = "es";
I18n.locale = "es";
window.I18n = I18n;
window.$ = $;
window.jQuery = $;
window._ = _;
window.global = window;
window.select2 = select2();

document.addEventListener("DOMContentLoaded", () => {

  const notificationsContainer = document.getElementById("global-notifications");
  if (notificationsContainer) {
    const notificationsRef = React.createRef();
    const root = createRoot(notificationsContainer);
    root.render(<Notifications ref={notificationsRef} />);

    window.notifications = {
      addNotification: (title, message, type) =>
        notificationsRef.current.addNotifications(title, message, type),
    };
  }

  const referenceElement = document.querySelector('#reference');
  const popperElement = document.querySelector('#popper');
  if (referenceElement && popperElement) {
    createPopper(referenceElement, popperElement);
  }

  const tokenElement = document.querySelector('meta[name="csrf-token"]');
  if (tokenElement) {
    window.Hupe8 = {
      token: tokenElement.content,
    };
  }

  $(".select2").select2({
    theme: "bootstrap-5"
  });

  $('.navbar-nav>li>a').on('click', function () {
    $('.navbar-collapse').collapse('hide');
  });

});

function initScopedSelect2() {
  const root = document.querySelector('.js-admin-filters');
  if (!root || !window.$ || !$.fn.select2) return;

  root.querySelectorAll('select.select2').forEach((el) => {
    if (el.dataset.enhanced === '1') return;

    $(el).select2({
      width: 'resolve',
      theme: 'bootstrap-5',
      placeholder: el.dataset.placeholder || '',
      allowClear: false
    });

    // Mostrar el control una vez que Select2 montó
    el.classList.remove('select2-preload');
    el.dataset.enhanced = '1';
  });
}

document.addEventListener('turbo:load', initScopedSelect2);
document.addEventListener('DOMContentLoaded', initScopedSelect2);


